import type { AdSettingPageEntry, AdSettingsApiEntry, AdSettingsResponse, } from '../api';

export const getAdSettingPages = (
  entry: AdSettingsApiEntry | undefined,
): AdSettingPageEntry[] => {
  if (!entry) {
    return [];
  }

  if ('page' in entry && entry.page != null && !Array.isArray(entry.page)) {
    return [entry.page];
  }

  if ('pages' in entry && Array.isArray(entry.pages)) {
    return entry.pages;
  }

  return [];
};

export const pickDefaultAdSettingItem = <T>(
  items: readonly T[] | undefined,
): T | undefined =>
  items?.find((item) => {
    if (typeof item !== 'object' || item == null) {
      return false;
    }

    return Boolean((item as { is_default?: boolean }).is_default);
  }) ?? items?.[0];

export const normalizeAdSettingsResponse = (
  data: Record<string, AdSettingsApiEntry>,
): AdSettingsResponse =>
  Object.fromEntries(
    Object.entries(data).map(([flowName, entry]) => [
      flowName,
      {
        pages: getAdSettingPages(entry),
        texts: entry.texts ?? [],
      },
    ]),
  );
